import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Button } from './ui/Button';
export function LocalSEO() {
  return <section className="py-24 bg-white" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-222">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-223">
            {/* Map Placeholder */}
            <div className="relative h-64 lg:h-auto bg-gray-700" data-id="element-224">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-225">
                <div className="text-center" data-id="element-226">
                  <MapPin className="w-16 h-16 text-wh-pink mx-auto mb-4" data-id="element-227" />
                  <p className="text-white font-semibold" data-id="element-228">LaGrange, Indiana</p>
                  <p className="text-gray-400 text-sm" data-id="element-229">
                    Northeast Indiana Service Area
                  </p>
                </div>
              </div>
              {/* Decorative dots */}
              <div className="absolute inset-0 bg-pop-dots opacity-5" data-id="element-230"></div>
            </div>

            {/* Content */}
            <div className="p-12 flex flex-col justify-center text-white" data-id="element-231">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-232">
                Proudly Serving{' '}
                <span className="text-wh-yellow" data-id="element-233">Northeast Indiana</span>
              </h2>

              <p className="text-gray-300 text-lg mb-6 leading-relaxed" data-id="element-234">
                Located in LaGrange, Indiana, we're your local source for custom
                apparel and promotional printing. We serve businesses, schools,
                and organizations throughout Northeast Indiana and beyond.
              </p>

              <div className="space-y-4 mb-8" data-id="element-235">
                <div className="flex items-start gap-3" data-id="element-236">
                  <MapPin className="w-5 h-5 text-wh-pink flex-shrink-0 mt-1" data-id="element-237" />
                  <div data-id="element-238">
                    <p className="font-semibold" data-id="element-239">4425 West US 20, Suite 1</p>
                    <p className="text-gray-400" data-id="element-240">LaGrange, Indiana 46761</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-241">
                  <Navigation className="w-5 h-5 text-wh-teal flex-shrink-0 mt-1" data-id="element-242" />
                  <div data-id="element-243">
                    <p className="font-semibold" data-id="element-244">Local Pickup Available</p>
                    <p className="text-gray-400" data-id="element-245">
                      Monday–Friday, 8:00 AM to 4:00 PM EST
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-246">
                <Button variant="primary" data-id="element-247">
                  Contact Our Indiana Print Shop
                </Button>
                <Button variant="secondary" data-id="element-248">Get Directions</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}